export const baseURL = 'https://'+import.meta.env.VITE_DOMAIN_NAME+'/v1/'

export const websocketURL = 'wss:websocket-'+import.meta.env.VITE_DOMAIN_NAME+'/v1'
// export const exceptThisSymbols = ['e', 'E', '+', '-', '.',''];
// export const branchLiveKey =process.env.REACT_APP_BRANCH_LIVE_KEY
export const CDN = "https://"+import.meta.env.VITE_CDN_URL+"/public/";

export const identityPoolId = import.meta.env.VITE_ADMIN_COGNITO_IDENTITY_POOL_ID;

export const viteRegion = import.meta.env.VITE_REGION || 'us-east-1';

export const userpoolId = import.meta.env.VITE_ADMIN_COGNITO_USERPOOL_ID

export const stage = import.meta.env.VITE_COMMON_LIB_ARN_PYTHON_2
